import {
  ChangeDetectionStrategy,
  Component,
  DestroyRef,
  inject,
  input,
  OnChanges,
  OnDestroy,
  output,
} from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

import { tap } from 'rxjs';

import { ImportSkillsFlowFacade } from '@core/tellent-skills-smart-ui';
import { ImportSkillsApplyResult } from '@core/tellent-skills-types';
import { TellentWebComponent } from '@core/tellent-types';

@Component({
  selector: 'x-import-skills-dialog',
  template: ``,
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [],
})
export class TellentImportSkillsDialogWrapComponent implements OnChanges, OnDestroy {
  private readonly facade = inject(ImportSkillsFlowFacade);
  private readonly destroyRef = inject(DestroyRef);
  #open = false;

  public open = input(false);
  public afterClosed = output<ImportSkillsApplyResult | undefined>();

  public ngOnChanges(): void {
    if (!this.open() || this.#open) return;

    this.#open = true;
    this.facade
      .startImportFlowAsTellentClientCompatibleStream()
      .pipe(
        takeUntilDestroyed(this.destroyRef),
        tap(() => (this.#open = false)),
      )
      .subscribe(value => this.afterClosed.emit(value));
  }

  // Close the tellent-client dialog and complete the completion stream so the
  // host (e.g. Grow) doesn't leave an orphan dialog on the overlay if it
  // unmounts this WC mid-flow.
  public ngOnDestroy(): void {
    if (this.#open) this.facade.cancelFlow();
  }
}

export type TellentImportSkillsDialogWebComponent = TellentWebComponent<
  TellentImportSkillsDialogWrapComponent,
  'open' | 'afterClosed'
>;
